export default [
  {
    key: 'date',
    name: '时间',
    type: 'dimension',
    parent: 'base_info'
  },
  {
    key: 'region',
    name: '大区',
    type: 'dimension',
    parent: 'base_info',
    chartProportion: true,
    branches: [
      {
        key: 'region_id',
        name: '大区ID',
        isShow: false,
        parent: 'base_info',
        trunk: 'region'
      },
      {
        key: 'region_name',
        name: '大区',
        parent: 'base_info',
        trunk: 'region'
      }
    ]
  }
];
